import { type ReactNode } from 'react';
import Breadcrumb, { type Crumb } from '@/components/feature/Breadcrumb';

interface PageHeaderProps {
  crumbs: Crumb[];
  eyebrow?: string;
  title: string;
  description?: string;
  children?: ReactNode;
}

export default function PageHeader({ crumbs, eyebrow, title, description, children }: PageHeaderProps) {
  return (
    <section className="relative overflow-hidden border-b border-background-200">
      <div className="pointer-events-none absolute -right-20 -top-24 h-64 w-64 rounded-full bg-primary-100/60 blur-3xl" />
      <div className="pointer-events-none absolute -left-16 bottom-0 h-56 w-56 rounded-full bg-accent-100/60 blur-3xl" />
      <div className="relative mx-auto w-full max-w-[1280px] px-4 pb-10 pt-8 md:px-6 md:pb-14 md:pt-10">
        <Breadcrumb items={crumbs} />
        {eyebrow && (
          <span className="mt-6 inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] text-primary-600">
            <span className="h-px w-6 bg-primary-400" />
            {eyebrow}
          </span>
        )}
        <h1 className="mt-2.5 font-heading text-3xl tracking-wide text-foreground-950 md:text-5xl">{title}</h1>
        {description && (
          <p className="mt-3.5 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">{description}</p>
        )}
        {children}
      </div>
    </section>
  );
}